module.exports = __webpack_public_path__ + "static/media/ic-fix-work.25eadaa0.svg";